var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadgray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 21.148C13.1654 21.148 13.3002 21.0133 13.3002 20.848V2.02422L19.197 7.92102C19.2556 7.97961 19.3329 8.00891 19.4091 8.00891C19.4852 8.00891 19.5626 7.97962 19.6212 7.92102C19.7384 7.80384 19.7384 7.614 19.6212 7.49679L13.2123 1.08789C13.0951 0.970703 12.9053 0.970703 12.7881 1.08789L6.37915 7.49679C6.26196 7.61398 6.26196 7.80381 6.37915 7.92102C6.49634 8.03821 6.68617 8.03821 6.80338 7.92102L12.7002 2.02422V20.848C12.7002 21.0133 12.8349 21.148 13.0002 21.148Z",
    fill: "#747272",
    stroke: "#747272",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 10.4686H17.104C16.9388 10.4686 16.804 10.6034 16.804 10.7686C16.804 10.9339 16.9388 11.0686 17.104 11.0686H21.7C23.1883 11.0686 24.4 12.2804 24.4 13.7686V21.7C24.4 23.1883 23.1883 24.4 21.7 24.4H4.3C2.81173 24.4 1.6 23.1883 1.6 21.7V13.7686C1.6 12.2804 2.81173 11.0686 4.3 11.0686H8.896C9.06124 11.0686 9.196 10.9339 9.196 10.7686C9.196 10.6034 9.06124 10.4686 8.896 10.4686H4.3C2.48008 10.4686 1 11.9487 1 13.7686V21.7C1 23.52 2.48008 25 4.3 25H21.7C23.5199 25 25 23.52 25 21.7V13.7686C25 11.9487 23.5199 10.4686 21.7 10.4686Z",
    fill: "#747272",
    stroke: "#747272",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadgray);
export default __webpack_public_path__ + "static/media/uploadgray.25a891babe60c9ea53e75f4410a0047c.svg";
export { ForwardRef as ReactComponent };